import type { NegociacaoTemperature, TemperatureIconType } from '../types/negociacoesUiTypes';
import { createElement, type ReactElement } from 'react';
import { FeatherFlame, FeatherThermometer, FeatherSnowflake } from '@subframe/core';

interface TemperatureMeta {
  iconType: TemperatureIconType;
  colorClass: string;
  description: string;
}

export const getTemperatureMeta = (temperature: NegociacaoTemperature): TemperatureMeta => {
  if (temperature === 'Quente') {
    return {
      iconType: 'flame',
      colorClass: 'text-error-600',
      description: 'Alta probabilidade de acordo',
    };
  }

  if (temperature === 'Morna') {
    return {
      iconType: 'thermometer',
      colorClass: 'text-warning-600',
      description: 'Probabilidade média de acordo',
    };
  }

  return {
    iconType: 'snowflake',
    colorClass: 'text-information-600',
    description: 'Baixa probabilidade de acordo',
  };
};

export const getTemperatureHoverClassName = (temperature: NegociacaoTemperature) => {
  if (temperature === 'Quente') {
    return 'hover:border-error-100 hover:bg-error-100';
  }

  if (temperature === 'Morna') {
    return 'hover:border-warning-100 hover:bg-warning-100';
  }

  return 'hover:border-information-100 hover:bg-information-100';
};

export const getTemperatureIcon = (temperature: NegociacaoTemperature): ReactElement => {
  const meta = getTemperatureMeta(temperature);
  const className = 'h-4 w-4';

  if (meta.iconType === 'flame') return createElement(FeatherFlame, { className });
  if (meta.iconType === 'thermometer') return createElement(FeatherThermometer, { className });
  return createElement(FeatherSnowflake, { className });
};
